import {graphql} from 'react-relay'

export const pipelineHeadQuery = graphql`
  query PipelinesPagesHeadQuery($locator: String!) {
    project(projectLocator: $locator) {
      ...pipelineHeadFragment
    }
  }
`
